<template>
  <div
    :class="internalExpanded ? 'items-start' : 'items-center'"
    class="flex justify-between gap-2 w-full"
  >
    <div class="flex-1">
      <slot v-if="internalExpanded" name="expanded" />
      <slot v-else name="collapsed" />
    </div>
    <i
      :class="['mdi', internalExpanded ? 'mdi-chevron-up' : 'mdi-chevron-down', 'truncate-toggle']"
      :title="internalExpanded ? $t('titletags.collapse') : $t('titletags.expand')"
      @click="toggleExpansion"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref, watch } from 'vue';

import { useTableExpandedColumnsStore } from '@/stores/tableExpandedColumns';

const props = defineProps<{
  isExpanded?: boolean;
  dataKey: string;
  field: string;
}>();

const emit = defineEmits<{
  (e: 'update:isExpanded', value: boolean): void;
  (e: 'toggleExpansion', field: string): void;
}>();

const store = useTableExpandedColumnsStore();

const internalExpanded = ref(false);

onMounted(() => {
  internalExpanded.value = store.isColumnExpanded(props.dataKey, props.field);
});

// Watch for changes in the store (when other cells in the same column toggle)
watch(
  () => store.isColumnExpanded(props.dataKey, props.field),
  (newVal) => {
    internalExpanded.value = newVal;
  },
);

watch(
  () => props.isExpanded,
  (val) => {
    if (val !== undefined) {
      internalExpanded.value = val;
    }
  },
);

function toggleExpansion(event: MouseEvent) {
  event.stopPropagation();
  const newState = !internalExpanded.value;
  internalExpanded.value = newState;
  store.setExpandedColumn(props.dataKey, props.field, newState);
  emit('update:isExpanded', newState);
  emit('toggleExpansion', props.field);
}
</script>
